import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import { GlobalStyle } from '@/helpers_site/globalStyle';

const Std = () => {
  return (
    <>
      
     <GlobalStyle /> 
      <App />   
      
    </>

  );
};

const rootElement = document.getElementById('stdR');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<Std />);
} else {
  console.error("Elemento 'stdR' não encontrado no DOM.");
}